export enum CheckoutPageId {
  DepartingFlights = 'departing',
  ReturningFlights = 'returning',
  AirportTransfers = 'airport-transfers',
  Experiences = 'experiences',
  Review = 'review',
  Payment = 'payment',
  Purchase = 'purchase',
  Dates = 'dates',
  LuxPlus = 'lux-plus',
  AddFlights = 'flights',
  TourV1Capacity = 'tour-capacity',
  TourV1Departure = 'tour-departure',
  TourV2Upgrade = 'tours-package',
  TourV2OptionalExperience = 'tours-optional-extras',
  TourV2Departures = 'tours-departures',
  TourV2Accommodation = 'tours-accommodation',
  ChangeDates = 'change-dates',
  ChangePackage = 'change-package',
  AddExtraGuests = 'add-extra-guests',
  InsuranceSelectDates = 'insurance-select-dates',
  InsuranceAddExtraGuests = 'insurance-add-extra-guests',
  BedbankChangeDates = 'partner-change-dates',
  BedbankChangePackage = 'partner-change-package',
  // cruises
  CruiseTravelers = 'cruise-travellers',
  CruiseCabinType = 'cruise-cabin-type',
  CruiseCabinCategory = 'cruise-cabin-category',
  CruiseCabinLocation = 'cruise-cabin-location',
  CruiseCabinPackage = 'cruise-cabin-package',
  CruiseHotelRecommendation = 'cruise-hotel-recommendation',
  CharterUpgrade = 'charter-upgrade',
}

const mobileAppLikeCheckoutStepIds = new Set<string>([
  CheckoutPageId.Review,
  CheckoutPageId.Payment,
])

const checkoutReviewAndPaymentStepIds = new Set<string>([
  CheckoutPageId.Purchase,
  CheckoutPageId.Review,
  CheckoutPageId.Payment,
])

const checkoutPaymentStepIds = new Set<string>([
  CheckoutPageId.Purchase,
  CheckoutPageId.Payment,
])

/**
 * Forward upsell steps where adding to the cart should re-validate an applied
 * promo/voucher discount (GR-4872). Deliberately excludes flight-selection
 * (`departing`/`returning`, already covered by promoReapplicationMiddleware once
 * fares resolve), the review/payment steps (owned by SingleCheckoutPage), and
 * every post-purchase / change / insurance / tour / cruise step.
 */
const promoRevalidationUpsellStepIds = new Set<string>([
  CheckoutPageId.LuxPlus,
  CheckoutPageId.AddFlights,
  CheckoutPageId.Experiences,
  CheckoutPageId.AirportTransfers,
])

export function isMobileAppLikeCheckoutStepId(stepId: string): boolean {
  return mobileAppLikeCheckoutStepIds.has(stepId)
}

export function isCheckoutReviewAndPaymentStepId(stepId?: string): boolean {
  return !!stepId && checkoutReviewAndPaymentStepIds.has(stepId)
}

export function isCheckoutPaymentStepId(stepId?: string): boolean {
  return !!stepId && checkoutPaymentStepIds.has(stepId)
}

export function isPromoRevalidationUpsellStepId(stepId?: string): boolean {
  return !!stepId && promoRevalidationUpsellStepIds.has(stepId)
}
